import { render, staticRenderFns } from "./ResidentDataPrintPrescriptionLote.vue?vue&type=template&id=0a09b4c9&"
import script from "./ResidentDataPrintPrescriptionLote.vue?vue&type=script&lang=js&"
export * from "./ResidentDataPrintPrescriptionLote.vue?vue&type=script&lang=js&"
import style0 from "./ResidentDataPrintPrescriptionLote.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports